import { Component, OnInit, OnDestroy } from "@angular/core";
import { NotificationModel, UserService, AuthService, PushNotificationService, GeoService } from "@bt/core";
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import * as $ from 'jquery';
import { Router } from "@angular/router";
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DeleteUserModalContent } from '@bt/admin/all-users/delete-users-modal';
import { PushNotifIdsModel } from '../core/models/pushNotifToDel.model';
import { PushNotifSortingModel } from "@bt/core/models/pushNotifSortingModel";
import { faSearch, faCopy } from '@fortawesome/free-solid-svg-icons';
import { DatePipe } from '@angular/common';
import { environment } from "@bt/environments";
import { ImageModalPush } from "./push-notif-image-modal";
const apiUrl = environment.apiUrl;

@Component({
  selector: "app-push-notification",
  templateUrl: "./push-notification.component.html",
  styleUrls: ["./push-notification.component.scss"]
})
export class PushNotificationComponent extends BaseComponent implements OnInit {

  faSearch = faSearch;
  faCopy = faCopy;

  private isSmthChecked = false;
  public pushNotificationList: NotificationModel[];
  public isResponsed: boolean = false;
  public hasInfo: boolean = false;
  //public stopped: boolean = false;
  public search: string = "";
  public modalRef: NgbModalRef;
  public pushNotificationToDelete: PushNotifIdsModel;
  public pushNotificationToDuplicate: PushNotifIdsModel;
  public filternotif: PushNotifSortingModel;
  public defaultDate: number;
  public today: string;
  public tomorrow: string;
  public result: string;
  public pipe = new DatePipe('en-US');
  notifier: any;
  public img: string = '';
  public isModalOpen: boolean = false;
  public src: string = '';
  notificationGeoOptions: any = [];

  constructor(
    private pushNotificationService: PushNotificationService,
    private notifierService: NotifierService,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private userService: UserService,
    private geoService: GeoService
  ) {
    super();
    this.pushNotificationList = [];
    this.notifier = notifierService;

  }

  public ngOnInit() {

    this.filternotif = new PushNotifSortingModel();

    var todayDate = new Date();
    var day = todayDate.getDate();
    var year = todayDate.getFullYear();
    var month = todayDate.getMonth();

    this.filternotif.beginDate = new Date(year, month, day).toDateString();
    this.filternotif.endDate = new Date(year, month, day + 1).toDateString();
    this.today = new Date(year, month, day).toDateString();
    this.today = this.pipe.transform(this.filternotif.beginDate, 'dd.MM.yyyy');
    this.tomorrow = new Date(year, month, day + 1).toDateString();
    this.tomorrow = this.pipe.transform(this.filternotif.endDate, 'dd.MM.yyyy');

    this.loadListNotifications();

    var dp1 = (<any>window).$('.regDate').datepicker({
      multipleDates: true,
      autoClose: true,

      onSelect: function (fd, dates, inst) {
        t.defaultDate = 1;
        if (dates) {
          t.defaultDate = 0;
          if (dates[0] && dates[1]) {
            t.filternotif.beginDate = dates[0].toDateString();
            if (dates.length > 1) {
              t.filternotif.endDate = dates[1].toDateString();
            }
          } else
            if (dates[0]) {
              t.filternotif.beginDate = dates[0].toDateString();
              t.filternotif.endDate = dates[0].toDateString();
            }
        }
      }

    }).data('datepicker');
    var t = this;
    t.GetGeos();
  }

  GetGeos(){
    var t = this;
    t.setLoading(true);
    t.geoService.GetGeos()
    .then((resp) => {
      for(let geo of resp.data){
        t.notificationGeoOptions.push({label: geo.name, value: geo.id});
        if(geo.name.indexOf('Все') != -1) t.filternotif.geoId = geo.id;
      }
      t.setLoading(false);
    })
    .catch((error)=>{
      t.setLoading(false);
      t.notifier.notify('error', "Ошибка при получении элементов Гео");
    });
  }

  public playOrStopNotification(notifModel: NotificationModel) {
    this.setLoading(true);
    this.pushNotificationService.startOrStopNotification(notifModel.id)
      .then((resp) => {
        if (resp) {
          if (notifModel.isStoped) this.notifierService.notify('success', 'Рассылка запущена');
          else this.notifierService.notify('success', 'Рассылка остановлена');
        }
        else {
          this.notifierService.notify('error', 'Ошибка при остановке или запуске рассылки');
        }
        this.loadListNotifications();
        this.setLoading(false);
      })
      .catch((er) => {
        this.notifierService.notify('error', 'Ошибка при остановке или запуске рассылки');
        this.setLoading(false);
      })

  }

  public pushNotifTimeOutput(time: string) {
    var timeOutput = "Error";
    var outTimeHour = Number(time.split(':')[0]);
    var outTimeMinute = Number(time.split(':')[1]);
    if (outTimeHour < 10) {
      timeOutput = "0" + outTimeHour;

    } else timeOutput = outTimeHour.toString();

    if (outTimeMinute < 10) {
      timeOutput = timeOutput + ":0" + outTimeMinute;

    } else timeOutput = timeOutput + ":" + outTimeMinute

    return timeOutput;
  }

  pushStatus(pushNotification: NotificationModel) {
    if (!pushNotification.isActual) return "Завершено";
    if (pushNotification.isStoped) return "Остановлено"; else return "Активно"
  }

  geoOutput(pushNotification: NotificationModel) {
    if (pushNotification.geo == 0) return "Все Гео";
    else return pushNotification.geo;
  }

  public loadListNotifications() {
    var t = this;
    t.setLoading(true);
    this.pushNotificationService.getListNotifications(this.filternotif)
      .then((resp) => {
        this.hasInfo = resp.data.length != 0;
        this.pushNotificationList = resp.data;


        this.pushNotificationList.forEach(pushNotif => {
          pushNotif.virtualPath1 = !!pushNotif.virtualPath1 ? (apiUrl + pushNotif.virtualPath1) : '';
          pushNotif.virtualPath2 = !!pushNotif.virtualPath2 ? (apiUrl + pushNotif.virtualPath2) : '';
          pushNotif.time = this.pushNotifTimeOutput(pushNotif.time);
          pushNotif.endTime = this.pushNotifTimeOutput(pushNotif.endTime);
        });
        t.setLoading(false);
        this.isResponsed = true;
      })
      .catch((error) => {
        this.hasInfo = false;
        this.notifierService.notify('error', 'Ошибка подгрузки данных');
        t.setLoading(false);
        this.isResponsed = true;
      });
  }

  public openDuplicateDomains(){
    let t = this;
    t.modalRef = t.modalService.open(DeleteUserModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true,
        size: 'sm',
        windowClass: 'super-modal-delete-users very-nice-shadow',

      });
    t.modalRef.componentInstance.isNeedDelete = false;
    t.modalRef.componentInstance.title = "Дублирование";
    t.modalRef.componentInstance.description = "Вы действительно хотите дублировать отмеченное?";
    t.modalRef.componentInstance.button = "Дублировать";
    t.modalRef
      .result.then((result) => {
        if (result) {
          t.pushNotificationToDuplicate = new PushNotifIdsModel();
          t.pushNotificationToDuplicate.ids = [];
          t.pushNotificationList.forEach(toDuplicate => {
            if (toDuplicate.isDeleted) {
              t.pushNotificationToDuplicate.ids.push(toDuplicate.id);
            }
          });

          t.pushNotificationService.duplicatePushNotification(t.pushNotificationToDuplicate)
            .then((resp) => {
              if (resp.data == true) {
                t.notifier.notify('success', "Успешно дублировано");
                t.loadListNotifications();
              }
            })
            .catch((error) => {
              t.notifier.notify('error', "Ошибка при дублировании рассылок");
            });
        }
      },
        (reason) => {
          //если отменили нажали на крестик или мимо окна
        })
  }

  public openDeleteDomains() {
    let t = this;
    t.modalRef = t.modalService.open(DeleteUserModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true,
        size: 'sm',
        windowClass: 'super-modal-delete-users very-nice-shadow',

      });
    t.modalRef.componentInstance.isNeedDelete = false;
    t.modalRef.componentInstance.title = "Удаление";
    t.modalRef.componentInstance.description = "Вы действительно хотите удалить отмеченное?";
    t.modalRef.componentInstance.button = "Удалить";
    t.modalRef
      .result.then((result) => {
        if (result) {
          t.pushNotificationToDelete = new PushNotifIdsModel();
          t.pushNotificationToDelete.ids = [];
          t.pushNotificationList.forEach(toDel => {
            if (toDel.isDeleted) {
              t.pushNotificationToDelete.ids.push(toDel.id);
            }
          });

          t.pushNotificationService.deletePushNotification(t.pushNotificationToDelete)
            .then((resp) => {
              if (resp.data == true) {
                t.notifier.notify('success', "Успешно удалено");
                t.loadListNotifications();
              }
            })
            .catch((error) => {
              t.notifier.notify('error', "Ошибка при удалении рассылок");
            });
        }
      },
        (reason) => {
          //если отменили нажали на крестик или мимо окна
        })
  }

  public isChecked() {
    this.isSmthChecked = false;
    this.pushNotificationList.forEach(user => {
      if (user.isDeleted == true) {
        this.isSmthChecked = true;
      }
    });

    return this.isSmthChecked;
  }

  public uncheckUsers() {
    this.pushNotificationList.forEach(user => {
      user.isDeleted = false;
    });
  }

  public editNotification(notif: NotificationModel) {
    this.router.navigateByUrl("app/push-notification-editor/" + notif.id);

  }
  public createNotification() {
    this.router.navigateByUrl("app/push-notification-create");

  }

  public getRole(): number {
    return this.userService.getRole();
  }


  public clearRegDate() {
    var t = this;
    (<any>window).$(".regDate").val("");
    (<any>window).$('.regDate').datepicker().data('datepicker').clear();
    this.filternotif.beginDate = "";
    this.filternotif.endDate = "";
  }

  public modalOpen(imgId: string, id: number){
    let t = this;
    imgId = imgId.replace(id.toString(), '');
    if(imgId == 'icon'){
      this.src = this.pushNotificationList[id].virtualPath1
    }else{
      this.src = this.pushNotificationList[id].virtualPath2
    }

    t.modalRef = t.modalService.open(ImageModalPush,
      {
        backdropClass: 'light-white-backdrop',
        centered: true,
        size: 'sm',
        windowClass: 'super-modal-delete-users very-nice-shadow',

      });
    t.modalRef.componentInstance.imgId = this.src;
    t.modalRef
    .result.then((result) => {

    },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/push-notification/push-notification.component.ts